import type { WriteIdentity } from '@/core/api/http'
import { apiPatch, apiPost } from '@/core/api/resources'
import type { DokumentCreate, DokumentPatch } from '@/core/data/dokumente'

export async function createDokument(row: DokumentCreate, identity?: WriteIdentity): Promise<string> {
  return (await apiPost('/azav/dokumente', row, identity)).id
}

export async function patchDokument(dokumentId: string, patch: DokumentPatch, identity?: WriteIdentity): Promise<void> {
  await apiPatch('/azav/dokumente/{id}', { id: dokumentId }, patch, identity)
}
